export const DEFAULT_SEARCH = ''
export const DEFAULT_IS_LOADING = false
export const INPUT_MAX_LENGTH = 140
export const SEARCH_AI_INPUT_ID = 'search-ai-input-id'

export const BASE_ELEMENTS_TYPES = {
  LABEL: 'label'
}

export const NO_OP = () => {}
